module.exports = __webpack_public_path__ + "images/emails/bg-warning-stripe@2x-287267ea.png";